import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../tanstack-query/queryClient'
import type { LeaveTypesApiResponse } from '../../components/onboarding-wizard/types'

const LEAVE_LAWS_URL = `${process.env.REACT_APP_API_URL}/core/leave-laws`

export const useLeaveTypesApi = () =>
  useQuery({
    queryKey: queryKeys.onboarding.leaveTypeTemplates(),
    queryFn: async (): Promise<LeaveTypesApiResponse> => {
      const response = await fetch(LEAVE_LAWS_URL)
      if (!response.ok) throw new Error(`Failed to fetch leave laws: ${response.status}`)
      return response.json() as Promise<LeaveTypesApiResponse>
    },
  })
